import React, { Component } from "react";

class VolunteerUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M18.8,5.1h-0.3c-0.4,0-0.7,0.1-1,0.3V4.1c0-1.3-1-2.3-2.3-2.3h-0.3c-0.4,0-0.7,0.1-1,0.3
	C13.7,0.9,12.7,0,11.5,0h-0.3C10,0,9,0.9,8.9,2.1c-0.3-0.2-0.7-0.3-1-0.3H7.5c-1.3,0-2.3,1-2.3,2.3v9.8l-1.1-1.1
	c-0.9-0.9-2.3-0.9-3.2,0L0.7,13c-0.9,0.9-0.9,2.3,0,3.2l4.4,4.4l2.2,2c0.7,0.7,1.6,1.1,2.6,1.2l6.3,0v0c2.7-0.2,4.9-2.5,4.9-5.3V7.4
	C21.1,6.1,20,5.1,18.8,5.1z M19.8,18.6c0,2.2-1.8,4.1-4.1,4.1h-5.5c-0.8,0-1.5-0.3-2.1-0.9l0,0l-2.2-2l-4.4-4.4
	c-0.2-0.2-0.3-0.5-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7l0.2-0.2c0.4-0.4,1.1-0.4,1.5,0l3.3,3.2V4.1c0-0.6,0.5-1,1-1h0.3c0.6,0,1,0.5,1,1
	V11h1.3V2.3c0-0.6,0.5-1,1-1h0.3c0.6,0,1,0.5,1,1V11h1.3V4.1c0-0.6,0.5-1,1-1h0.3c0.6,0,1,0.5,1,1V11h1.3V7.4c0-0.6,0.5-1,1-1h0.3
	c0.6,0,1,0.5,1,1V18.6z M16.4,15.4c0,0.5-0.2,0.9-0.5,1.2l-2.8,2.8l-2.9-2.8l0,0c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1-0.2-0.1-0.4-0.1-0.6
	c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6c0-0.9,0.7-1.6,1.6-1.6C15.6,13.8,16.4,14.5,16.4,15.4z"
        />
      </svg>
    );
  }
}

export default VolunteerUpSVG;



// WEBPACK FOOTER //
// ./src/svg/VolunteerUpSVG.jsx